module.exports = __webpack_public_path__ + "img/insignaLogo.34e8dcfb.jpg";